import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  NON_VISUAL_PUNCHTHRU_ACTIONS,
  VISUAL_PUNCHTHRU_ACTIONS,
} from '@usf/ngrx-order';

/**
 * Service to handle punchthru login events related to order
 */
@Injectable({
  providedIn: 'root',
})
export class OrderLoginPunchthruService {
  constructor(private store: Store) {}

  loadVptOrder(): void {
    this.store.dispatch(VISUAL_PUNCHTHRU_ACTIONS.loadVptOrder());
  }

  loadNvptOrder(): void {
    this.store.dispatch(NON_VISUAL_PUNCHTHRU_ACTIONS.loadNvptOrder());
  }
}
